import React, { useState } from 'react'
import styled from 'styled-components'
import { useStoreState, useStoreActions } from 'easy-peasy'
import ErrorMessage from './ErrorMessage'
import Text, { useTranslations } from '../../utils/Text'

const Container = styled.div`
  /* margin: 21px auto 25px; */
  margin: 44px auto 20px;
`

const Wrapper = styled.div`
  max-width: 443px;
  margin: 0 auto;
  position: relative;
  width: 100%;
  color: #818181;
`

const Input = styled.input`
  border-radius: 0;
  font-size: 16px !important;
  width: 100%;
  height: 49px;
  border: none;
  border-bottom: 1px solid #818181 !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  padding-left: 10px;
  padding-right: 10px;
  &:focus {
    border-bottom: 1px solid #414141 !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    outline: none;
    box-shadow: none;
  }
`

const Label = styled.label`
  position: absolute;
  pointer-events: none;
  font-size: 16px;
  left: 10px;
  top: 10px;
  transition: 0.3s ease all;
  ${Input}:focus ~ & {
    top: -12px;
    font-size: 12px;
  }
  ${Input}:not([value=""]) ~ & {
    top: -12px;
    font-size: 12px;
  }
`

export default function InputText({ name, ...props }) {
  const { optional } = props
  const [{ label }, error] = useStoreState(state => [
    state.form.getByName(name),
    state.form.getErrorByName(name),
  ])

  const [setInputValue] = useStoreActions(actions => [
    actions.form.setInputValue,
  ])

  const [value, setValue] = useState('')

  const isOptional = useTranslations(label, { optional })
  if (optional && isOptional === undefined) return null

  return (
    <Container>
      <Wrapper>
        <Input
          id={`text-${name}`}
          name={name}
          value={value}
          onChange={({ target: { value: val } }) => {
            setValue(val)
          }}
          onBlur={() => {
            setInputValue({ name, value })
          }}
        />
        <Label htmlFor={`text-${name}`}>
          <Text id={label} />
        </Label>
        <ErrorMessage
          error={error}
          id={`error-${name}`}
          className="error"
        />
      </Wrapper>
    </Container>
  )
}
